<template>
  <div>
    <Row :gutter="16">
      <Col span="12">
      <Card :bordered="false">
        <p slot="title">
          组织结构
        </p>
        <!-- <Button slot="extra" size="small" type="primary" @click="createUnitVisible=true">新增组织根节点</Button> -->
        <Tree :data="organizationList" id="orgTree" :render="renderContent">

        </Tree>
      </Card>
      </Col>
      <Col span="12">
      <Card :bordered="false">
        <p slot="title">
          成员
        </p>
        <!-- <Button slot="extra" size="small" type="primary" @click="addUsersVisible=true">添加人员</Button> -->
        <Table :columns="columnsRender" :data="orgUsersList"></Table>
      </Card>
      </Col>
    </Row>
    <createUnit :visible="createUnitVisible" @input="endInput" :unitData="createUnitData" @operateSuccess="operateSuccess" :unitModel="unitModel"></createUnit>
    <selectUsers :visible="addUsersVisible" @input="endAddInput" :orgId="addUserOrgId" @addSuccess="addSuccess"></selectUsers>
  </div>
</template>

<script>
import ajax from '../../../lib/ajax';
import createUnit from './createUnit'
import selectUsers from './selectUsers'

export default {
  data() {
    return {
      organizationList: [],
      createUnitVisible: false,
      createUnitData: {
        parentId: null
      },
      unitModel: {
        unitName: '',
        type: 'create'
      },
      selectOrg: {},
      addUsersVisible: false,
      addUserOrgId: 0,
      orgUsersList: [],
      columnsRender: [
        {
          title: '名字',
          key: 'name'
        },
        {
          title: '添加时间',
          key: 'addedTime',
          width: 100,
          render: (h, params) => {
            return h('div', new Date(params.row.addedTime.replace('T', ' ')).toLocaleDateString())
          }
        },
        {
          title: '操作',
          key: 'action',
          width: 75,
          align: 'center',
          render: (h, params) => {
            return h('div', [
              h('Button', {
                props: {
                  type: 'error',
                  size: 'small'
                },
                on: {
                  click: () => {
                    this.removeOrgUser(params.row)
                  }
                }
              }, '删除')
            ])
          }
        }
      ],
      lastSelected: ''
    }
  },
  created() {
    this.refreshOrganizationList()
  },
  methods: {
    async refreshOrganizationList() {
      let rep = await ajax.get('/api/services/app/OrganizationUnit/GetOrganizationUnits');
      // 拷贝一个数组
      let copyOrgList = []
      const itemList = rep.data.result.items.reverse()
      itemList.forEach(item => {
        copyOrgList.push({
          title: `${item.displayName}(${item.memberCount})`,
          id: item.id,
          parentId: item.parentId,
          orgTitle: item.displayName
        })
      })
      // 子组织归并
      for (let i = itemList.length - 1; i >= 0; i--) {
        let item = itemList[i]
        if (item.parentId) {
          for (let j = 0; j < copyOrgList.length; j++) {
            if (copyOrgList[j].id === item.parentId) {
              copyOrgList[j].expand = true
              copyOrgList[j].children = copyOrgList[j].children || []
              copyOrgList[j].children.push(copyOrgList.splice(i, 1)[0])
              break
            }
          }
        }
      }
      this.organizationList = copyOrgList
    },
    renderContent(h, { root, node, data }) {
      return h('span', {
        'class': {
          'org-item': true
        },
        // style: {
        //   display: 'inline-block',
        //   width: '100%',
        //   cursor: 'pointer',
        // },
        on: {
          click: (e) => {
            if (e.target.className.indexOf('org-item') === -1 && e.target.className.indexOf('select-parent') === -1) return
            let target = e.target
            if (target.className.indexOf('select-parent') !== -1) {
              target = target.parentNode
            }
            if (this.lastSelected !== '') {
              this.lastSelected.className = this.lastSelected.className.replace(' selected', '')
            }
            target.className += ' selected'
            this.lastSelected = target
            this.chooseOrgItem(data)
          }
        }
      }, [
          h('span', {
            'class': {
              'select-parent': true
            },
          }, data.title),
          // h('span', {
          //   style: {
          //     display: 'inline-block',
          //     float: 'right',
          //     marginRight: '0'
          //   }
          // }, [
          //     h('Button', {
          //       props: {
          //         type: 'success',
          //         size: 'small'
          //       },
          //       style: {
          //         marginRight: '8px'
          //       },
          //       on: {
          //         click: () => { this.append(data) }
          //       }
          //     }, '添加'),
          //     h('Button', {
          //       props: {
          //         type: 'primary',
          //         size: 'small'
          //       },
          //       style: {
          //         marginRight: '8px'
          //       },
          //       on: {
          //         click: () => { this.edit(root, node, data) }
          //       }
          //     }, '编辑'),
          //     h('Button', {
          //       props: {
          //         type: 'error',
          //         size: 'small'
          //       },
          //       on: {
          //         click: () => { this.remove(root, node, data) }
          //       }
          //     }, '删除')
          //   ])
        ]);
    },
    append(data) {
      // const children = data.children || [];
      // children.push({
      //   title: 'appended node',
      //   expand: true
      // });
      // this.$set(data, 'children', children);
      this.createUnitData.parentId = data.id
      this.createUnitVisible = true
    },
    remove(root, node, data) {
      // const parentKey = root.find(el => el === node).parent;
      // const parent = root.find(el => el.nodeKey === parentKey).node;
      // const index = parent.children.indexOf(data);
      // parent.children.splice(index, 1);
      let self = this
      this.$Modal.confirm({
        title: '删除组织节点',
        content: `是否确定删除组织节点：${data.title}`,
        loading: true,
        async onOk() {
          try {
            let rep = await ajax.delete('/api/services/app/OrganizationUnit/DeleteOrganizationUnit', { params: { id: data.id } })
            self.$Modal.remove();
            self.$Message.info('删除成功');
            self.refreshOrganizationList()
          } catch (err) {
            console.error(err)
            self.$Modal.remove();
            self.$Message.info('删除失败');
          }
        }
      });
    },
    edit(root, node, data) {
      // title删除人数
      const numIndex = data.title.lastIndexOf('(')
      this.unitModel = {
        unitName: data.title.slice(0, numIndex),
        type: 'edit'
      }
      this.createUnitData.parentId = data.id
      this.createUnitVisible = true
    },
    endInput(val) {
      if (!val) {
        this.createUnitVisible = false
        this.createUnitData.parentId = null
        this.unitModel = {
          unitName: '',
          type: 'create'
        }
      }
    },
    endAddInput(val) {
      if (!val) {
        this.addUsersVisible = false
      }
    },
    operateSuccess() {
      this.refreshOrganizationList()
    },
    addSuccess() {
      this.addUsersVisible = false
      this.$Message.info('添加成功')
      this.chooseOrgItem({ id: this.addUserOrgId })
      this.refreshOrganizationList()
    },
    async chooseOrgItem(data) {
      this.selectOrg = data
      this.addUserOrgId = data.id
      let params = {
        Id: this.addUserOrgId,
        MaxResultCount: 100, // 每页数量,获取全部
        SkipCount: 0 // 开始条数
      }
      let rep = await ajax.get('/api/services/app/OrganizationUnit/GetOrganizationUnitUsers', { params: params })
      if (rep.data.success) {
        this.orgUsersList = rep.data.result.items
      }
    },
    removeOrgUser(row) {
      this.$Modal.confirm({
        title: '提示',
        content: `确认删除组织${this.selectOrg.orgTitle}的成员${row.name}`,
        onOk: async () => {
          let rep = await ajax.delete('/api/services/app/OrganizationUnit/RemoveUserFromOrganizationUnit', {
            params: {
              userId: row.id,
              organizationUnitId: this.selectOrg.id
            }
          })
          if (rep.data.success) {
            this.$Message.success('删除成功')
            // 刷新人员
            this.chooseOrgItem(this.selectOrg)
          }
        }
      })
    }
  },
  components: {
    createUnit,
    selectUsers
  }
}
</script>

<style lang="less">
#right-menu {
  width: 0; /*设置为0 隐藏自定义菜单*/
  height: 75px;
  overflow: hidden; /*隐藏溢出的元素*/
  box-shadow: 0 1px 1px #888, 1px 0 1px #ccc;
  position: absolute; /*自定义菜单相对与body元素进行定位*/
  .menu {
    width: 130px;
    height: 25px;
    line-height: 25px;
    padding: 0 10px;
  }
}
.org-item {
  display: inline-block;
  width: 92%;
  padding: 3px 5px;
  cursor: pointer;
  &:hover {
    background: rgba(45, 140, 240, 0.2);
    border-radius: 5px;
  }
}
.selected {
  background: rgba(45, 140, 240, 0.2);
  border-radius: 5px;
}
</style>
